import { createApp } from 'vue'
import App from './App.vue'

document.querySelectorAll('.aie-descriptions-cx').forEach((element) => {
  // Get the account ID and placement ID from the element's attributes
  const accountId = element.getAttribute('data-account-id')
  let vin = element.getAttribute('data-vin') ?? ''

  let currentElement: Element | null = element

  // Get VIN from element props or closest parent element
  while (vin === '' && currentElement && currentElement.nodeName !== 'BODY') {
    currentElement = currentElement.parentElement
    vin = currentElement?.getAttribute('data-vin') ?? ''
  }

  const app = createApp(App, {
    accountId: accountId,
    vin: vin,
  })
  app.mount(element)
})
